import EmailComposerError from '../services/errors/emailComposerError';

const openComposerEmailComposerPlugin = (message, subject, to, cc, bcc) => {
  if (!window || !window.email) {

    return Promise.reject(new EmailComposerError('EmailComposer is not installed'));
  }

  return new Promise(resolve => {
    window.email.open(
      {
        to, // email addresses for TO field
        cc, // email addresses for CC field
        bcc, // email addresses for BCC field
        subject, // subject of the email
        body: message, // email body
      },
      resolve,
    );
  });
};

export default openComposerEmailComposerPlugin;
